import { toastr } from 'react-redux-toastr';

export const GetLocation = () => async (dispatch) => 
{
  let location;
  let counter = 0;

  try 
  {
    let watchID = navigator.geolocation.watchPosition(
      function(position) 
        {
          location = [position.coords.latitude.toFixed(6) , position.coords.longitude.toFixed(6)];
    
          dispatch({type: 'SET_LOCATION', location : location});
          dispatch({type: 'SET_CENTER', center : location});

          if(counter === 0)
          {            
            setTimeout(() => 
            {
              dispatch({type: 'SET_ZOOM', zoom : 16});
            }, 500);
          }

          counter++;
        },
      function(error)
        {
          switch(error.code) 
          {
            case error.PERMISSION_DENIED:
              toastr.error("CONSTRUVISOR", 'SE DEBE ACTIVAR GEOLOCALIZACIÓN');
              break;
            case error.POSITION_UNAVAILABLE:
              toastr.error("CONSTRUVISOR", 'NO EXISTE INFORMACIÓN');
              break;
            case error.TIMEOUT:
              toastr.error("CONSTRUVISOR", 'CONEXIÓN LENTA DE INTERNET');
              break;
            case error.UNKNOWN_ERROR:
              console.log("CONSTRUVISOR", 'ERROR ENCONTRADO PARA OBTENER UBICACIÓN');
              break;
            default:
            toastr.error("CONSTRUVISOR", 'NO SE PUEDE OBTENER UBICACIÓN');
          }

          dispatch({type: 'SET_LOCATION', location : [-0.144236, -78.475527]});
          dispatch({type: 'SET_CENTER', center : [-0.144236, -78.475527]});
          dispatch({type: 'SET_ZOOM',zoom : 15});
        },
        {
          enableHighAccuracy: true,
          timeout: 1000,
          //maximumAge: 0
        }
      );

    setTimeout(() => 
    {
      navigator.geolocation.clearWatch(watchID);
    }, 5000);

    dispatch({type: 'SET_PIN_MOVED', pinIsMoved : true});
  } 
  catch (error) 
  {
    console.log(error);
  }
}